import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import allocateRunnerENG from "./locales/eng/allocateRunner.json";
import allocateShippingUnitsENG from "./locales/eng/allocateShippingUnits.json";
import busENG from "./locales/eng/bus.json";
import commonENG from "./locales/eng/common.json";
import customerENG from "./locales/eng/customer.json";
import dashboardENG from "./locales/eng/dashboard.json";
import holidayENG from "./locales/eng/holiday.json";
import hubENG from "./locales/eng/hub.json";
import importManagementENG from "./locales/eng/importManagement.json";
import menuManagementENG from "./locales/eng/menuManagement.json";
import myOrdersENG from "./locales/eng/myOrders.json";
import notificationENG from "./locales/eng/notification.json";
import notificationManagementENG from "./locales/eng/notificationManagement.json";
import reportManagementENG from "./locales/eng/reportManagement.json";
import routeENG from "./locales/eng/route.json";
import shippingUnitENG from "./locales/eng/shippingUnit.json";
import timeslotENG from "./locales/eng/timeslot.json";
import translationENG from "./locales/eng/translation.json";
import transportLocalitiesENG from "./locales/eng/transportLocalities.json";
import userProfileENG from "./locales/eng/userProfile.json";
import paymentMethodENG from "./locales/eng/paymentMethod.json";
import timeslotCollectorENG from "./locales/eng/timeslotCollector.json";
import productENG from "./locales/eng/product.json";
import routeCollectorENG from "./locales/eng/routeCollector.json";
import allocateCollectorENG from "./locales/eng/allocateCollector.json";
import bloodOrderENG from "./locales/eng/bloodOrder.json";
import saleTeamsENG from "./locales/eng/saleTeams.json";
import auditLogsENG from "./locales/eng/auditLogs.json";
import runnerManagementENG from "./locales/eng/runnerManagement.json";
import ticketManagementENG from "./locales/eng/ticketManagement.json";
import priorityScheduleENG from "./locales/eng/prioritySchedule.json";

import allocateRunnerVN from "./locales/vn/allocateRunner.json";
import allocateShippingUnitsVN from "./locales/vn/allocateShippingUnits.json";
import busVN from "./locales/vn/bus.json";
import commonVN from "./locales/vn/common.json";
import customerVN from "./locales/vn/customer.json";
import dashboardVN from "./locales/vn/dashboard.json";
import holidayVN from "./locales/vn/holiday.json";
import hubVN from "./locales/vn/hub.json";
import importManagementVN from "./locales/vn/importManagement.json";
import menuManagementVN from "./locales/vn/menuManagement.json";
import myOrdersVN from "./locales/vn/myOrders.json";
import notificationVN from "./locales/vn/notification.json";
import notificationManagementVN from "./locales/vn/notificationManagement.json";
import orderVN from "./locales/vn/order.json";
import reportManagementVN from "./locales/vn/reportManagement.json";
import routeVN from "./locales/vn/route.json";
import shippingUnitVN from "./locales/vn/shippingUnit.json";
import timeslotVN from "./locales/vn/timeslot.json";
import translationVN from "./locales/vn/translation.json";
import transportVN from "./locales/vn/transport.json";
import transportLocalitiesVN from "./locales/vn/transportLocalities.json";
import userProfileVN from "./locales/vn/userProfile.json";
import orderStatisticVN from "./locales/vn/orderStatistic.json";
import paymentMethodVN from "./locales/vn/paymentMethod.json";
import timeslotCollectorVN from "./locales/vn/timeslotCollector.json";
import productVN from "./locales/vn/product.json";
import routeCollectorVN from "./locales/vn/routeCollector.json";
import allocateCollectorVN from "./locales/vn/allocateCollector.json";
import bloodOrderVN from "./locales/vn/bloodOrder.json";
import reasonVN from "./locales/vn/reason.json";
import saleTeamsVN from "./locales/vn/saleTeams.json";
import auditLogsVN from "./locales/vn/auditLogs.json";
import runnerManagementVN from "./locales/vn/runnerManagement.json";
import ticketManagementVN from "./locales/vn/ticketManagement.json";
import priorityScheduleVN from "./locales/vn/prioritySchedule.json";

const resources = {
  en: {
    translation: translationENG,
    common: commonENG,
    menuManagement: menuManagementENG,
    shippingUnit: shippingUnitENG,
    customer: customerENG,
    route: routeENG,
    bus: busENG,
    dashboard: dashboardENG,
    myOrders: myOrdersENG,
    reportManagement: reportManagementENG,
    userProfile: userProfileENG,
    importManagement: importManagementENG,
    allocateShippingUnits: allocateShippingUnitsENG,
    allocateRunner: allocateRunnerENG,
    notification: notificationENG,
    notificationManagement: notificationManagementENG,
    holiday: holidayENG,
    transportLocalities: transportLocalitiesENG,
    hub: hubENG,
    timeslot: timeslotENG,
    paymentMethod: paymentMethodENG,
    timeslotCollector: timeslotCollectorENG,
    product: productENG,
    routeCollector: routeCollectorENG,
    allocateCollector: allocateCollectorENG,
    bloodOrder: bloodOrderENG,
    saleTeams: saleTeamsENG,
    auditLogs: auditLogsENG,
    runnerManagement: runnerManagementENG,
    ticketManagement: ticketManagementENG,
    prioritySchedule: priorityScheduleENG,
  },
  vn: {
    translation: translationVN,
    common: commonVN,
    menuManagement: menuManagementVN,
    shippingUnit: shippingUnitVN,
    customer: customerVN,
    route: routeVN,
    bus: busVN,
    dashboard: dashboardVN,
    myOrders: myOrdersVN,
    order: orderVN,
    reportManagement: reportManagementVN,
    userProfile: userProfileVN,
    importManagement: importManagementVN,
    allocateShippingUnits: allocateShippingUnitsVN,
    allocateRunner: allocateRunnerVN,
    transport: transportVN,
    notification: notificationVN,
    notificationManagement: notificationManagementVN,
    holiday: holidayVN,
    transportLocalities: transportLocalitiesVN,
    hub: hubVN,
    timeslot: timeslotVN,
    orderStatistic: orderStatisticVN,
    paymentMethod: paymentMethodVN,
    timeslotCollector: timeslotCollectorVN,
    product: productVN,
    routeCollector: routeCollectorVN,
    allocateCollector: allocateCollectorVN,
    bloodOrder: bloodOrderVN,
    reason: reasonVN,
    saleTeams: saleTeamsVN,
    auditLogs: auditLogsVN,
    runnerManagement: runnerManagementVN,
    ticketManagement: ticketManagementVN,
    prioritySchedule: priorityScheduleVN,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "vn");
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "vn",
    fallbackLng: "en", // use en if detected lng is not available

    // keySeparator: true, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss,
      skipOnVariables: false, // Hide variables when not used
    },
    debug: false,
  });

export default i18n;
